export const permissions = {
  DASHBOARD: 'DASHBOARD',

  VIEW_INBOUND_PAYMENT_SUMMARY: 'VIEW_INBOUND_PAYMENT_SUMMARY',
  VIEW_OUTBOUND_PAYMENT_SUMMARY: 'VIEW_OUTBOUND_PAYMENT_SUMMARY',
  VIEW_KYC_COUNT_SUMMARY: 'VIEW_KYC_COUNT_SUMMARY',
  VIEW_TXN_SUMMARY: 'VIEW_TXN_SUMMARY', // Additional Claim

  ADDITIONAL_CLAIM_MENU: 'ADDITIONAL_CLAIM_MENU', // Business Profile

  BUSINESS_PROFILE_MENU: 'BUSINESS_PROFILE_MENU',
  VIEW_BUSINESS_PROFILE: 'VIEW_BUSINESS_PROFILE', // Partner Management

  PARTNER_MANAGEMENT_MENU: 'PARTNER_MANAGEMENT_MENU', // Partner List

  VIEW_PARTNER_LIST: 'VIEW_PARTNER_LIST',
  VIEW_PARTNER_BY_ID: 'VIEW_PARTNER_BY_ID',
  CREATE_PARTNER: 'CREATE_PARTNER',
  UPDATE_PARTNER: 'UPDATE_PARTNER',
  UPDATE_PARTNER_STATUS: 'UPDATE_PARTNER_STATUS',
  DELETE_PARTNER: 'DELETE_PARTNER',
  ALLOW_EXPORT_PARTNER: 'ALLOW_EXPORT_PARTNER', // Partner Credentials

  VIEW_PARTNER_CREDENTIALS_BY_PARTNERID: 'VIEW_PARTNER_CREDENTIALS_BY_PARTNERID',
  VIEW_PARTNER_CREDENTIAL_BY_ID: 'VIEW_PARTNER_CREDENTIAL_BY_ID',
  CREATE_PARTNER_CREDENTIAL: 'CREATE_PARTNER_CREDENTIAL',
  DELETE_PARTNER_CREDENTIAL: 'DELETE_PARTNER_CREDENTIAL', // Partner License

  VIEW_PARTNER_LICENSE_BY_PARTNERID: 'VIEW_PARTNER_LICENSE_BY_PARTNERID',
  CREATE_PARTNER_LICENSE: 'CREATE_PARTNER_LICENSE',
  UPDATE_PARTNER_LICENSE_ACTIVE_STATUS: 'UPDATE_PARTNER_LICENSE_ACTIVE_STATUS', // Partner License Map

  CREATE_PARTNER_LICENSE_MAP: 'CREATE_PARTNER_LICENSE_MAP',
  VIEW_PARTNER_LICENSE_MAP: 'VIEW_PARTNER_LICENSE_MAP',
  UPDATE_PARTNER_LICENSE_MAP_ACTIVE_STATUS: 'UPDATE_PARTNER_LICENSE_MAP_ACTIVE_STATUS', // Partner Corridors

  VIEW_PARTNER_COUNTRY_LIST: 'VIEW_PARTNER_COUNTRY_LIST',
  VIEW_PARTNER_COUNTRY_BY_ID: 'VIEW_PARTNER_COUNTRY_BY_ID',
  VIEW_PARTNER_COUNTRY_DETAIL_BY_ID: 'VIEW_PARTNER_COUNTRY_DETAIL_BY_ID',
  CREATE_PARTNER_COUNTRY: 'CREATE_PARTNER_COUNTRY',
  UPDATE_PARTNER_COUNTRY_STATUS: 'UPDATE_PARTNER_COUNTRY_STATUS',
  DELETE_PARTNER_COUNTRY: 'DELETE_PARTNER_COUNTRY', // Partner Funding Source

  VIEW_PARTNER_FUNDING_SOURCE_LIST: 'VIEW_PARTNER_FUNDING_SOURCE_LIST',
  VIEW_PARTNER_FUNDING_SOURCE_BY_ID: 'VIEW_PARTNER_FUNDING_SOURCE_BY_ID',
  CREATE_PARTNER_FUNDING_SOURCE: 'CREATE_PARTNER_FUNDING_SOURCE',
  UPDATE_PARTNER_FUNDING_SOURCE_STATUS: 'UPDATE_PARTNER_FUNDING_SOURCE_STATUS',
  DELETE_PARTNER_FUNDING_SOURCE: 'DELETE_PARTNER_FUNDING_SOURCE', // User Management

  USER_MANAGEMENT_MENU: 'USER_MANAGEMENT_MENU', // User Setup / Account List

  VIEW_ACCOUNT_LIST: 'VIEW_ACCOUNT_LIST',
  VIEW_ACCOUNT_BY_ID: 'VIEW_ACCOUNT_BY_ID',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  RESET_PASSWORD: 'RESET_PASSWORD',
  UPDATE_USER_STATUS: 'UPDATE_USER_STATUS',
  DELETE_USER: 'DELETE_USER', // Role Setup

  VIEW_ROLE_LIST: 'VIEW_ROLE_LIST',
  VIEW_ROLE_BY_ID: 'VIEW_ROLE_BY_ID',
  CREATE_ROLE: 'CREATE_ROLE',
  UPDATE_ROLE: 'UPDATE_ROLE',
  UPDATE_ROLE_STATUS: 'UPDATE_ROLE_STATUS',
  DELETE_ROLE: 'DELETE_ROLE',
  SAVE_ROLE_CLAIM: 'SAVE_ROLE_CLAIM', // Transactions

  TRANSACTION_MENU: 'TRANSACTION_MENU', // All Transactions

  VIEW_TRANSACTION_LIST: 'VIEW_TRANSACTION_LIST',
  VIEW_TRANSACTION_BY_ID: 'VIEW_TRANSACTION_BY_ID',
  UPDATE_TRANSACTION_STATUS: 'UPDATE_TRANSACTION_STATUS',
  UPDATE_BNB_TXN_STATUS: 'UPDATE_BNB_TXN_STATUS',
  TRACK_REPORT: 'TRACK_REPORT',
  EXPORT_TRANSACTION: 'EXPORT_TRANSACTION',
  VIEW_TXN_LOG_BY_TXN_ID: 'VIEW_TXN_LOG_BY_TXN_ID',
  VIEW_TRANSACTION_RECEIPT: 'VIEW_TRANSACTION_RECEIPT',
  UPDATE_BNB_REJECTED_TXN: 'UPDATE_BNB_REJECTED_TXN', 

  VIEW_PAYMENT_VERIFYING_TXN_LIST: 'VIEW_PAYMENT_VERIFYING_TXN_LIST',
  VIEW_PAYMENT_VERIFYING_TXN_BY_ID: 'VIEW_PAYMENT_VERIFYING_TXN_BY_ID', 

  CUSTOMER_MENU: 'CUSTOMER_MENU', 

  VIEW_CUSTOMER_BY_PARTNER_ID: 'VIEW_CUSTOMER_BY_PARTNER_ID',
  VIEW_CUSTOMER_BY_ID: 'VIEW_CUSTOMER_BY_ID',
  VIEW_CUSTOMER_DOCUMENT_BY_ID: 'VIEW_CUSTOMER_DOCUMENT_BY_ID',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  UPDATE_CUSTOMER_ACCOUNT_BNB: 'UPDATE_CUSTOMER_ACCOUNT_BNB',
  EXPORT_CUSTOMER: 'EXPORT_CUSTOMER',
  SYNC_KAASI_KYC: 'SYNC_KAASI_KYC', 

  VIEW_CUSTOMER_KYC_LIST: 'VIEW_CUSTOMER_KYC_LIST',
  VIEW_CUSTOMER_KYC_BY_ID: 'VIEW_CUSTOMER_KYC_BY_ID',
  UPDATE_USER_KYC_STATUS: 'UPDATE_USER_KYC_STATUS',
  UPDATE_ISEND_USER_KYC_STATUS: 'UPDATE_ISEND_USER_KYC_STATUS',
  VIEW_CUSTOMER_KYC_COUNT: 'VIEW_CUSTOMER_KYC_COUNT',
  VIEW_EKYC_VERIFICATION_LIST: 'VIEW_EKYC_VERIFICATION_LIST',
  EXPORT_CUSTOMER_KYC: 'EXPORT_CUSTOMER_KYC', 

  VIEW_BENEFICIARY_LIST: 'VIEW_BENEFICIARY_LIST',
  VIEW_BENEFICIARY_BY_ID: 'VIEW_BENEFICIARY_BY_ID',
  VIEW_BENEFICIARY_BY_USERID: 'VIEW_BENEFICIARY_BY_USERID',
  EXPORT_BENEFICIARY: 'EXPORT_BENEFICIARY', 

  REPORT_MENU: 'REPORT_MENU',

  VIEW_PAYIN_LIST: 'VIEW_PAYIN_LIST',
  VIEW_PAYIN_BY_ID: 'VIEW_PAYIN_BY_ID',

  VIEW_PAYOUT_LIST: 'VIEW_PAYOUT_LIST',
  VIEW_PAYOUT_BY_ID: 'VIEW_PAYOUT_BY_ID',

  AUS_TRACK_REPORT: 'AUS_TRACK_REPORT', 

  MASTER_SETUP_MENU: 'MASTER_SETUP_MENU', 

  VIEW_LICENSING_PARTNER_LIST: 'VIEW_LICENSING_PARTNER_LIST',
  VIEW_LICENSING_PARTNER_BY_ID: 'VIEW_LICENSING_PARTNER_BY_ID',
  CREATE_LICENSE_PARTNER: 'CREATE_LICENSE_PARTNER',
  UPDATE_LICENSING_PARTNER: 'UPDATE_LICENSING_PARTNER',
  DELETE_LICENSING_PARTNER: 'DELETE_LICENSING_PARTNER', 

  VIEW_FUNDING_SOURCE_LIST: 'VIEW_FUNDING_SOURCE_LIST',
  VIEW_FUNDING_SOURCE_BY_ID: 'VIEW_FUNDING_SOURCE_BY_ID',
  CREATE_FUNDING_SOURCE: 'CREATE_FUNDING_SOURCE',
  UPDATE_FUNDING_SOURCE_STATUS: 'UPDATE_FUNDING_SOURCE_STATUS',
  DELETE_FUNDING_SOURCE: 'DELETE_FUNDING_SOURCE', 

  VIEW_FUNDING_SOURCE_INFO_LIST: 'VIEW_FUNDING_SOURCE_INFO_LIST',
  VIEW_FUNDING_SOURCE_INFO_BY_ID: 'VIEW_FUNDING_SOURCE_INFO_BY_ID',
  CREATE_FUNDING_SOURCE_INFO: 'CREATE_FUNDING_SOURCE_INFO',
  UPDATE_FUNDING_SOURCE_INFO: 'UPDATE_FUNDING_SOURCE_INFO',
  DELETE_FUNDING_SOURCE_INFO: 'DELETE_FUNDING_SOURCE_INFO', 

  VIEW_API_CONFIG_LIST: 'VIEW_API_CONFIG_LIST',
  VIEW_API_CONFIG_BY_ID: 'VIEW_API_CONFIG_BY_ID',
  CREATE_API_CONFIG: 'CREATE_API_CONFIG',
  UPDATE_API_CONFIG: 'UPDATE_API_CONFIG', 

  VIEW_WEBHOOK_LIST: 'VIEW_WEBHOOK_LIST',
  VIEW_WEBHOOK_BY_ID: 'VIEW_WEBHOOK_BY_ID',
  CREATE_WEBHOOK: 'CREATE_WEBHOOK',
  UPDATE_WEBHOOK: 'UPDATE_WEBHOOK',
  DELETE_WEBHOOK: 'DELETE_WEBHOOK', 

  VIEW_WEBHOOK_HEADER_LIST: 'VIEW_WEBHOOK_HEADER_LIST',
  VIEW_WEBHOOK_HEADER_BY_ID: 'VIEW_WEBHOOK_HEADER_BY_ID',
  CREATE_WEBHOOK_HEADER: 'CREATE_WEBHOOK_HEADER',
  UPDATE_WEBHOOK_HEADER: 'UPDATE_WEBHOOK_HEADER',
  DELETE_WEBHOOK_HEADER: 'DELETE_WEBHOOK_HEADER', 

  VIEW_MENU_LIST: 'VIEW_MENU_LIST',
  VIEW_MENU_DETAIL: 'VIEW_MENU_DETAIL',
  VIEW_MENU_BY_ID: 'VIEW_MENU_BY_ID',
  CREATE_MENU: 'CREATE_MENU',
  UPDATE_MENU: 'UPDATE_MENU',
  DELETE_MENU: 'DELETE_MENU',
  VIEW_MENU_BY_MENY_TYPE: 'VIEW_MENU_BY_MENY_TYPE',
};
